import { createSlice } from '@reduxjs/toolkit';

export const customCounsellingFourSlice = createSlice({
  name: 'customCounsellingFour',
  initialState: {
    allDataFour: null,
  },
  reducers: {
    setAllDataFour: (state, action) => {
      state.allDataFour = action.payload;
    },
  },
});

export const { setAllDataFour } = customCounsellingFourSlice.actions;
export default customCounsellingFourSlice.reducer;
